import { createFileRoute } from '@tanstack/react-router'
import { ActionsPage } from '~/features/listing-actions/components/actions-page'

export const Route = createFileRoute('/dashboard/actions')({
  validateSearch: (search: Record<string, unknown>) => ({
    listingId: typeof search.listingId === 'string' ? search.listingId : undefined,
  }),
  component: ActionsRoute,
})

function ActionsRoute() {
  const { listingId } = Route.useSearch()
  return <ActionsPage key={listingId} listingId={listingId} />
}
